import { render, staticRenderFns } from "./tambah_projek.vue?vue&type=template&id=623dd563&scoped=true"
import script from "./tambah_projek.vue?vue&type=script&lang=js"
export * from "./tambah_projek.vue?vue&type=script&lang=js"
import style0 from "./tambah_projek.vue?vue&type=style&index=0&id=623dd563&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623dd563",
  null
  
)

export default component.exports